/*
 * @Author: WLL
 * @Date: 2020-04-29 14:06:28
 * @LastEditors: WLL
 * @LastEditTime: 2020-05-01 11:36:11
 * @Description: 个股盈利预测页面接口
 */
import http from "@/utils/http";

export default {
  async getStockList(params) {
    return await http.post("stock/profit_predict", params);
  }
};
